import styled from 'styled-components';

export const TableList = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: space-between;
    margin: 0 50px;
    flex-wrap: wrap;
`;

export const Title = styled.h2`
    font-size: 18px;
    color: rgba(255,255,255, 0.5);
    margin-right: 20px;
    text-transform: uppercase;
    font-weight: 100;
`;

export const ButtonIcon = styled.div`
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    width: 25px;
    height: 25px;
    min-width: 25px;
    min-height: 25px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: color .3s ease 0s, background-color .3s ease 0s;

    :hover {
        color: ${props => props.hoverColor || '#fff' };
        background-color: ${props => props.color};
    }

    &:not(:last-child) {
        margin-right: 10px;
    }
    
    &:before {
        transition: color .4s ease 0s;
        content: '${props => props.icon}';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'Material Design Icons';
        font-size: 16px;
        color: ${props => props.color};
    }

    &:hover:before {
        color: #000;
    }
`;

export const HeaderRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 50px 50px 30px;
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 30px 50px 20px;

    &.noTopDistance {
        padding-top: 0;
    }
`;

export const PaginatorRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 30px;
`;

export const FilterPresentation = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px;
    border: 1px solid #39f;
    color: #39f;
    margin: 0 50px 20px;
    background-color: rgba(0,0,255, 0.2);
`;

export const ButtonBack = styled.div`
    border: 0px;
    width: 30px;
    min-width: 30px;
    height: 30px;
    min-height: 30px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    transition: color .3s ease 0s;
    margin-right: 10px;

    &:before {
        transition: color .4s ease 0s;
        content: '\\F004D';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'Material Design Icons';
        font-size: 25px;
        color: ${props => props.color};
    }

    &:hover:before {
        color: "#fff";
    }
`;

export const NoItemsFilter = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #888;
    
    &:before {
        content: '\\F120D';
        color: #444;
        font-family: "Material Design Icons";
        font-size: 200px;
        margin-bottom: 20px;
    }
`;

export const NoItems = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #888;
    
    &:before {
        content: '\\F1874';
        color: #666;
        font-family: "Material Design Icons";
        font-size: 200px;
        margin-bottom: 20px;
    }
`;